<template>
  <div class="home-container">
    <van-skeleton animate :row="12" :loading="loading" />
    <div v-show="!loading" class="pdf-con">
      <iframe id="pdf-viewer" :src="'https://css.mycst.cn/pdfframe/pdfviewer/web/viewer.html?file=' + pdfUrl" frameborder="0"></iframe>
    </div>
    <div class="tool-bar">
      <div class="flex">
        <van-checkbox-group class="checkbox-group-horizontal" v-model="lx">
          <div>附件：</div>
          <van-checkbox class="mr10" name="PDF" checked-color="#409eff" shape="square">PDF</van-checkbox>
          <van-checkbox class="mr10" name="OFD" checked-color="#409eff" shape="square">OFD</van-checkbox>
          <van-checkbox class="mr10" name="XML" checked-color="#409eff" shape="square">XML</van-checkbox>
        </van-checkbox-group>
        <van-button type="info" size="small" color="#409eff" @click="download('lx', lx)">打包下载</van-button>
      </div>
      <div class="share-con">
        <input class="yxdz" v-model="khyj" type="text" placeholder="请输入邮箱地址" />
        <van-button @click="shareTo" class="share-btn" :disabled="disYjbtn" type="warning" block icon="envelop-o">转发</van-button>
      </div>
      <!-- <van-button class="change-fp-btn"  @click="huanPiao" type="info" block icon="exchange">换票</van-button> -->
    </div>
    <div class="change-fpzl-con" v-show="showChangeFpzl">
      <change-fpzl ref="changeFp" />
    </div>
    <div class="change-fpzl">
      <van-icon name="question-o" />
      <span style="margin-left: 2px">不是我想要的发票 </span>
      <template v-if="gsInfo?.zdhc == 1">
        <span @click="huanPiao" class="sqhp-btn">申请换票</span>
        <span class="sqhp-btn">|</span>
      </template>
      <span @click="download" class="sqhp-btn">下载发票</span>
    </div>
  </div>
</template>

<script>
import { Base64 } from "js-base64";
import Vue from "vue";
import { Toast, Icon, Button, Skeleton, Dialog, Checkbox, CheckboxGroup } from "vant";
Vue.use(Dialog).use(Toast).use(Icon).use(Button).use(Skeleton).use(Checkbox).use(CheckboxGroup);
import { mapState } from "vuex";
import axios from "axios";
// const urlHead = window.urlHead;

export default {
  components: {
    "change-fpzl": () => import("@/pages/changeFpzl"),
  },
  computed: {
    ...mapState(["dhInfo", "fpInfo", "InvoiceInfo", "FPZL", "gsInfo"]),
  },
  props: {},
  data() {
    return {
      lx: ["PDF"], // 交付文件类型
      pdfUrl: "", //当前pdf的地址
      loading: true,
      khyj: "", //邮件地址
      showChangeFpzl: false, //是否显示换票
      disYjbtn: false, //是否禁用邮箱按钮

      pdfAPI: "https://dz-fp.cn/DZFP/FP", //pdf接口
    };
  },
  methods: {
    download(type = "", lx = []) {
      console.log("this.fpInfo", this.fpInfo);
      console.log("this.dhInfo", this.dhInfo);
      if (type === "lx") {
        const postData = {
          cs: 0,
          yj: 0,
          ispdf: lx.includes("PDF") ? 1 : 0,
          isofd: lx.includes("OFD") ? 1 : 0,
          isxml: lx.includes("XML") ? 1 : 0,
          data: `[${Base64.encode(JSON.stringify([{ xtlsh: this.fpInfo.SucessList[0].XTLSH, fpzl: this.dhInfo.FPZL }]))}]`,
          spid: this.fpInfo.SPID,
          qysh: this.fpInfo.QYSH,
        };
        axios
          .post(urlHead + "/NEWKP/DZFP/PLXZ", this.formD(postData))
          .then((res) => {
            if (res.Result == "1" && res.ID) {
              window.open(`${urlHead}/NEWKP/dzfp/FILE?key=${res.ID}`);
            } else {
              Toast("文件缺失：" + (res?.ErrList?.map((item) => item.LX)?.join("，") || ""));
            }
          })
          .catch((err) => {
            console.log("err =>", err);
            Toast("网络异常");
          });
        return;
      }
      let downloadUrl = "";
      if (this.dhInfo.XYM) {
        downloadUrl = this.pdfAPI + `?${this.formD(this.dhInfo)}`;
      } else if (this.dhInfo.xtlsh) {
        downloadUrl = this.pdfAPI + "?XTLSH=" + this.fpInfo.SucessList[0].XTLSH + "&JE=" + this.fpInfo.JE + "&FPZL=" + this.fpInfo.FPZL + "&QYSH=" + this.fpInfo.QYSH;
      } else {
        downloadUrl = this.fpInfo.URL;
      }
      window.open(downloadUrl);
    },
    huanPiao() {
      Dialog.alert({
        title: "提示",
        message: "申请换票将作废原发票，确定申请换票？",
        showCancelButton: true,
      }).then(async () => {
        this.showChangeFpzl = true;
        this.$nextTick(() => {
          this.$refs.changeFp.getMatic(); //初始化
        });
      });
    },
    //确定转发邮箱
    shareTo() {
      if (this.khyj.match(/^[a-zA-Z0-9_-]+@[a-zA-Z0-9_-]+(\.[a-zA-Z0-9_-]+)+$/) == null) {
        Toast("请输入正确的邮箱😅");
        return;
      }
      if (this.lx.length === 0) {
        Toast("请选择要转发的附件");
        return;
      }
      this.disYjbtn = true;
      setTimeout(() => {
        this.disYjbtn = false;
      }, 1000);
      let postData = {
        khyj: this.khyj,
        fpzl: this.dhInfo.FPZL || this.fpInfo.FPZL || this.fpInfo.fpzl,
        lx: this.lx.join(","),
      };
      if (this.dhInfo.XYM) {
        postData.xym = this.dhInfo.XYM;
      } else {
        postData = {
          ...postData,
          spid: this.dhInfo.spid || "",
          fpzl: this.fpInfo.FPZL || this.fpInfo.fpzl || postData.fpzl || "",
          xtlsh: this.fpInfo.SucessList[0].XTLSH || "",
          je: this.fpInfo.JE || "",
          qysh: this.fpInfo.QYSH || "",
        };
      }
      axios
        .post(urlHead + "/NEWKP/KPGL/FPYJJH", this.formD(postData))
        .then((res) => {
          Toast(res.Message);
          if (res.Result == "1") this.khyj = "";
        })
        .catch((err) => {
          console.error("转发失败", err);
        });
    },
    formD(obj) {
      const formData = new URLSearchParams();
      Object.keys(obj).forEach((key) => {
        if (obj[key] instanceof Array) {
          obj[key].forEach((item) => {
            formData.append(key, item);
          });
          return;
        }
        formData.append(key, obj[key]);
      });
      return formData;
    },
    GetDownLoadurl() {
      let postData = {
        xym: this.dhInfo.XYM,
        fpzl: this.dhInfo.FPZL,
      };
      this.$store.commit("fpInfo", { ...this.dhInfo });
      this.$axios
        .post(urlHead + "/NEWKP/DZFP/GetDownLoadurl", this.formD(postData))
        .then((res) => {
          // {
          //     "Result": "1",
          //     "Message": "成功",
          //     "fphm": "12312312312312312312",
          //     "fpzl": "021",
          //     "fbmc": "_0306",
          //     "filename": "123123123123_12312312.pdf",
          //     "xtlsh": "de2d595153f4e198337364ac11dcc9f0",
          //     "spid": "178f408786694252a31fed704335d795",
          //     "xym": "5e946bc06e72471b"
          // }
          if (res.Result == "1") {
            let fpInfo = {
              ...this.dhInfo,
              JE: res.je || "",
              SPID: res.spid,
              FPZL: res.fpzl || this.dhInfo.FPZL || "",
              SucessList: [{ XTLSH: res.xtlsh }],
              DPID: res.dpid || "",
              KHMC: res.khmc || "",
              KHSH: res.khsh || "",
            };
            this.$store.commit("fpInfo", fpInfo);
          }
        })
        .catch(() => {});
    },
  },
  mounted() {
    console.log("FPZL", this.FPZL);
    console.log("fpInfo", this.fpInfo);
    console.log("dhInfo", this.dhInfo);
    console.log("InvoiceInfo", this.InvoiceInfo);
    if (this.dhInfo.XYM) this.GetDownLoadurl();
    this.$nextTick(() => {
      setTimeout(() => {
        this.loading = false;
      }, 1500);
      if (this.dhInfo.XYM) {
        // console.log('this.dhInfo.XYM',this.dhInfo.XYM);
        this.pdfUrl = encodeURIComponent(this.pdfAPI + `?${this.formD(this.dhInfo)}`);
      } else if (this.dhInfo.xtlsh) {
        let xtlsh = this.dhInfo.xtlsh;
        if (this.dhInfo.xtlsh.indexOf("^") !== -1) {
          xtlsh = this.dhInfo.xtlsh.split("^");
        } else if (this.dhInfo.xtlsh.indexOf("_") !== -1) {
          xtlsh = this.dhInfo.xtlsh.split("_");
        }
        this.pdfUrl = encodeURIComponent(this.pdfAPI + `?XTLSH=${xtlsh[0]}&JE=${xtlsh[1]}&QYSH=${xtlsh[2]}`);
        this.fpInfo.FPZL = this.fpInfo.FPZL || xtlsh[3] || "";
      } else {
        this.pdfUrl = encodeURIComponent(this.fpInfo.URL);
        // this.pdfUrl = encodeURIComponent(`${urlHead}/newkp/DZFP/FP?XTLSH=${this.fpInfo.SucessList[0].XTLSH}&JE=${this.fpInfo.JE}&FPZL=${this.fpInfo.FPZL}&QYSH=${this.fpInfo.QYSH}`);
      }
    });
  },
};
</script>

<style lang="less" scoped>
.home-container {
  background-color: #fff;
  padding: 10px 10px;
  border-radius: 15px;
  min-height: calc(100vh - 100px);
}
.change-fpzl {
  display: inline-block;
  font-size: 9pt;
  position: fixed;
  bottom: 15px;
  width: 100vw;
  text-align: center;
  color: #858585;
  .sqhp-btn {
    color: #ffa603;
    // color: #fff;
    padding: 0 3px;
  }
}
.change-fpzl-con {
  position: fixed;
  width: 100vw;
  height: 100vh;
  top: 0;
  left: 0;
  background: #fff;
  z-index: 3099;
  overflow-y: auto;
}
.pdf-con {
  margin: 12px auto;
  #pdf-viewer {
    width: 100%;
    height: 45vh;
  }
}
.tool-bar {
  margin: 24px auto 12px;
  color: #000;
  ::v-deep .van-checkbox__label {
    color: #000 !important;
  }
  .yxdz {
    height: 44px;
    line-height: 44px;
    width: 100%;
    box-sizing: border-box;
    padding: 0 12px;
    border: none;
    outline: none;
    // box-shadow: 0 0 1px #bbb;
  }
}
.share-con {
  margin: 16px 0;
  display: flex;
  border-radius: 6px;
  align-items: center;
  border: 1px solid #409eff;
  justify-content: flex-start;
  overflow: hidden;
  .share-btn {
    border-color: #409eff;
    background: #409eff;
    .van-button__content {
      background: #409eff;
    }
    border-radius: 0;
    width: 100px;
    border-top-right-radius: 6px;
    border-bottom-right-radius: 6px;
  }
}
.change-fp-btn {
  background: #409eff;
  border: 1px solid #298bfd;
  border-radius: 6px;
}
input {
  outline: none;
  -webkit-appearance: none;
  appearance: none;
  -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
}
.checkbox-group-horizontal {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-around;
}

//IOS点击阴影
select {
  -webkit-tap-highlight-color: transparent;
  -webkit-touch-callout: none;
  -webkit-user-select: none;
  user-select: none;
}

.flex {
  display: flex;
  justify-content: space-between;
}
.mr10 {
  margin-right: 10px;
}

// ::v-deep .van-checkbox__icon .van-icon {
// 	border-color: #fff;
// }
</style>
